import { NotificationTemplateDto } from '@halo/dtos/notification-template-dto'
import { SegmentDto } from '@halo/dtos/segment.dto'
import { NotificationDeliverySpec } from '@halo/dtos/notification-schedule-dto'
import { NotificationDefaultTemplateDto } from '@halo/dtos/notification-default-template.dto'
import { NotificationWebTemplateDto } from '@halo/dtos/notification-web-template.dto'
import { NotificationNativeIosTemplateDto } from '@halo/dtos/notification-native-ios-template.dto'

export class FeedNotificationPreviewDto {
    public static fromApiResponse(fields: Partial<FeedNotificationPreviewDto>): FeedNotificationPreviewDto {
        const dto = new FeedNotificationPreviewDto()
        Object.assign(dto, fields)
        return dto
    }

    public audience: {
        segments?: SegmentDto[]
        excluded_segment_ids?: number[]
        excluded_segments?: SegmentDto[]
        segment_ids?: number[]
        subscriber_ids?: string[]
        external_subscriber_ids?: string[]
        domain_ids?: number[]
    }
    public deliverySpec: NotificationDeliverySpec
    public source: string
    public template: {
        channels: {
            default: NotificationDefaultTemplateDto
            web: NotificationWebTemplateDto
            native_ios: NotificationNativeIosTemplateDto
            native_android: NotificationDefaultTemplateDto
        }
        keywords?: string[]
    }

    public get defaultTemplate(): NotificationDefaultTemplateDto {
        const channels: any = this.template?.channels ?? {}
        if (channels.native_ios || channels.native_android) {
            channels.default.alt_native_url = channels.native_ios?.landing_url ?? channels.native_android?.landing_url
        }
        return channels.default ?? {}
    }

    public get webTemplate(): NotificationWebTemplateDto {
        return this.template?.channels?.web ?? {}
    }

    public get nativeIosTemplate(): NotificationNativeIosTemplateDto {
        return this.template.channels?.native_ios ?? {}
    }

    public get nativeAndroidTemplate(): NotificationDefaultTemplateDto {
        return this.template?.channels?.native_android ?? ({} as NotificationDefaultTemplateDto)
    }

    public get keywords(): string[] {
        return this.template?.keywords ?? []
    }

    public set keywords(value) {
        const wrapper: any = this.template ?? {}
        wrapper.keywords = value
    }
}
